export default "__VITE_ASSET__BNYv7sIg__"